import React, {useEffect, useState} from "react";
import {
    Drawer,
    Box,
    TextField,

    FormControlLabel,
    Switch,
    Button, Snackbar,
} from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import {useForm} from "react-hook-form";
import Api from "../../Services/Api";
import Title from "../Title";
import {Alert, AlertTitle} from "@mui/material";
import {Autocomplete} from "@mui/material";
import MuiAlert from '@mui/material/Alert';



const CreateFeed = ({load, setLoading}) => {
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [demandFeeds, setDemandFeeds] = useState([]);
    const [supplyPartners, setSupplyPartners] = useState([]);
    const [supplyFeeds, setSupplyFeeds] = useState([]);
    const [openSnackbar, setOpenSnackbar] = useState(false);

    const [formType, setFormType] = useState("creation");
    const {
        register,
        handleSubmit,
        setValue,
        watch,
        reset,
        formState: {errors},
    } = useForm();

    const handleCloseSnackbar = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnackbar(false);
    };


    useEffect(() => {
        // You can set the initial state of the drawer here if needed

        Api.demandFeeds({}).then(r => {
            setDemandFeeds(r)
        })

        Api.supplyPartners({}).then(r => {
            setSupplyPartners(r)
        })

        Api.supply({}).then(r => {
            setSupplyFeeds(r)
        })
    }, [drawerOpen]);


    const handleDemandFeedChange = (_, value) => {
        setValue("demand_feed_id", value ? value.id : "");
        setValue("capping", value ? value.capping : "");
        console.log(value)
        if (value.supply_feeds_count > 1) {
            setValue("multipleFeedsWarning", true);
        } else {
            setValue("multipleFeedsWarning", false);
        }


        setValue(
            "name",
            value
                ? value.type.name +
                " - " +
                (value.mobile && value.desktop
                    ? "Mobile & Desktop"
                    : value.mobile
                        ? "Mobile"
                        : value.desktop
                            ? "Desktop"
                            : "")
                : ""
        );
    };
    const handleSupplyFeedChange = (_, value) => {
        setValue("publisher_id", value ? value.id : "");
        setValue("supply_margin", value ? value.current_margin?.margin : "");
    };

    const handleFormSubmit = async (data) => {
        console.log("Form data:", data);

        if (formType == "creation") {
            setLoading(true)
            await closeDrawer()
            await Api.supplyStore(data);
            await load()
            setOpenSnackbar(true)

            setLoading(false)
            console.log('done')
        } else {
            console.log('assignation')
            setLoading(true)
            await closeDrawer()
            await Api.supplyDemandStore(data);
            await load()
            setOpenSnackbar(true)

            setLoading(false)

        }

        // Handle form submission logic here
    };

    const handleFormTypeSwitch = (e) => {

        setFormType(e.target.checked ? "assignation" : "creation");
        reset()
    };


    const renderFormFields = () => {
        if (formType === "creation") {
            return (
                <>
                    <Box
                        sx={{
                            border: "1px solid", // Set the border width and style
                            borderColor: "primary.main", // Set the border color
                            borderRadius: 2, // Add border radius for rounded corners
                            p: 2, // Add padding inside the box
                            mt: 2,
                        }}
                    >
                        <Title>
                            Supply & Demand
                        </Title>
                        <Box mt={2}/>

                        <Autocomplete
                            options={supplyPartners}

                            getOptionLabel={(option) => `${option.id} - ${option.name}`}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Publisher ID"

                                    required
                                />
                            )}
                            onChange={handleSupplyFeedChange}
                            value={supplyPartners.find((supply) => supply.id === watch("publisher_id")) || null}
                            fullWidth
                        />
                        <Box mt={2}/>
                        <Autocomplete
                            options={demandFeeds}
                            getOptionLabel={(option) => `${option.id} - ${option.user.name} - ${option.type.name} - ${option.needle}`}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Demand Feed ID"

                                    required
                                />
                            )}
                            onChange={handleDemandFeedChange}
                            value={demandFeeds.find((feed) => feed.id === watch("demand_feed_id")) || null}
                            fullWidth
                        />
                    </Box>
                    <Box mt={2}/>

                    {watch('demand_feed_id') && watch('publisher_id') &&

                        <Box
                            sx={{
                                border: "1px solid", // Set the border width and style
                                borderColor: "primary.main", // Set the border color
                                borderRadius: 2, // Add border radius for rounded corners
                                p: 2, // Add padding inside the box
                                mt: 2,
                            }}
                        >
                            {true === watch("multipleFeedsWarning") &&
                                <>
                                    <Alert severity="warning">
                                        <AlertTitle>Warning</AlertTitle>
                                        Multiple feeds are assigned to this Demand, but it doesn't support multiple
                                        feeds. Please double-check before proceeding.
                                    </Alert>
                                    <Box mt={2}/>
                                </>}
                            <Title>
                                Feed Info
                            </Title>
                            <Box mt={2}/>
                            <TextField {...register("name", {required: true})} required={true} label="Name"
                                      fullWidth/>
                            <Box mt={2}/>
                            <TextField {...register("capping", {required: true})}  type={"number"} required={true} label="Capping" fullWidth/>
                            <Box mt={2}/>
                            <TextField {...register("supply_margin",)}  label="Rev Share" fullWidth required={true}/>
                            <Box mt={2}/>
                            <TextField {...register("antifraud_check",)} label="Anti Fraud Rate" InputLabelProps={{
                                shrink: true,
                            }} value={0.20} required={true} fullWidth/>
                            <Box mt={2}/>
                            <TextField {...register("internal_ma,e",)} label="Internal Name [optional]" InputLabelProps={{
                                shrink: true,
                            }}  value='' required={false} fullWidth/>
                            <FormControlLabel
                                control={
                                    <Switch
                                        {...register('active')}
                                        color="primary"
                                        defaultChecked={true}
                                    />
                                }
                                label="Active/Inactive"
                            />
                        </Box>}
                </>
            );
        } else {
            return (
                <>
                    <Box
                        sx={{
                            border: "1px solid", // Set the border width and style
                            borderColor: "primary.main", // Set the border color
                            borderRadius: 2, // Add border radius for rounded corners
                            p: 2, // Add padding inside the box
                            mt: 2,
                        }}
                    >
                        <Title>
                            Association
                        </Title>
                        <Box mt={2}/>
                        <Autocomplete
                            options={supplyFeeds}
                            getOptionLabel={(option) => `${option.id} - ${option.name}`}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Supply ID"

                                    required
                                />
                            )}
                            value={supplyFeeds.find((feed) => feed.id === watch("supply_feed_id")) || null}
                            onChange={(_, value) => setValue("supply_feed_id", value ? value.id : "")}

                            fullWidth
                        />


                        <Box mt={2}/>

                        <Autocomplete
                            options={demandFeeds}
                            getOptionLabel={(option) => `${option.id} - ${option.user.name} - ${option.type.name} - ${option.needle}`}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Demand ID"

                                    required
                                />
                            )}
                            value={demandFeeds.find((feed) => feed.id === watch("demand_feed_id")) || null}
                            onChange={(_, value) => setValue("demand_feed_id", value ? value.id : "")}

                            fullWidth
                        />
                    </Box>
                    {watch('demand_feed_id') && watch('supply_feed_id') &&
                        <Box
                            sx={{
                                border: "1px solid", // Set the border width and style
                                borderColor: "primary.main", // Set the border color
                                borderRadius: 2, // Add border radius for rounded corners
                                p: 2, // Add padding inside the box
                                mt: 2,
                            }}
                        >
                            <Title>
                                Association Config
                            </Title>
                            <Box mt={2}/>
                            <TextField {...register("capping", {required: true})} type={"number"} required={true} label="Capping" fullWidth/>

                        </Box>}

                </>
            );
        }
    };

    const closeDrawer = () => {
        setDrawerOpen(false);
        setFormType('creation')
        reset()
    }


    return (
        <>
            <Button variant="contained" onClick={() => setDrawerOpen(true)}>+ New Feed</Button>

            <Drawer anchor="right" open={drawerOpen} onClose={closeDrawer}>
                <Box sx={{width: 400, padding: 2}}>
                    <FormControlLabel
                        control={<Switch checked={formType === "assignation"} onChange={handleFormTypeSwitch}/>}
                        label="Assignation"
                    />
                    <Box mt={2}/>

                    <form onSubmit={handleSubmit(handleFormSubmit)}>
                        {renderFormFields()}
                        <Box mt={2}>
                            <Button variant="contained" color="primary" startIcon={<SaveIcon/>} type="submit">
                                Save
                            </Button>
                        </Box>
                    </form>

                </Box>
            </Drawer>
            <Snackbar open={openSnackbar} autoHideDuration={6000} onClose={handleCloseSnackbar}>
                <MuiAlert onClose={handleCloseSnackbar} severity="success" variant="filled">
                    Saved Successfully!
                </MuiAlert>
            </Snackbar>
        </>
    );
};

export default CreateFeed;
